import { Box, Heading, Table, Thead, Tbody, Tr, Th, Text, useBreakpointValue } from "@chakra-ui/react";
import RecentCheckItem from './RecentCheckBadgesItem';
import { useEffect, useState } from 'react';

const RecentChecksBadgesList = ({ recentChecks, onSelectAddress, onClear }) => {
	const [sortedChecks, setSortedChecks] = useState([]);
	const [isAscending, setIsAscending] = useState(true);
	const isMobile = useBreakpointValue({ base: true, md: false });

	const handleClearRecentChecks = () => {
		onClear();
	};

	const sortByBadges = () => {
		const sorted = [...sortedChecks].sort((a, b) => {
			// Используйте badgeCount для сортировки
			return isAscending ? a.badgeCount - b.badgeCount : b.badgeCount - a.badgeCount;
		});
		setSortedChecks(sorted);
		setIsAscending(prev => !prev);
	};

	useEffect(() => {
		const initialSortedChecks = [...recentChecks].sort((a, b) => b.badgeCount - a.badgeCount);
		setSortedChecks(initialSortedChecks);
	}, [recentChecks]);

	const handleDelete = (address) => {
		const updatedChecks = sortedChecks.filter(check => check.address !== address);
		localStorage.setItem('recentBadgesChecks', JSON.stringify(updatedChecks));
		setSortedChecks(updatedChecks); // Эта строка вызовет анимацию исчезновения
	};

	return (
		sortedChecks.length > 0 && (
			<Box mt={12}>
				<Heading size="md" mb={6} textAlign={"center"}>
					Recent Checks
				</Heading>

				{/* Table for recent checks */}
				<Table variant="simple" size="sm">
					<Thead background={"gray.100"}>
						<Tr>
							<Th>Address</Th>
							<Th textAlign="center">Rank</Th>
							<Th textAlign="center" onClick={sortByBadges} cursor="pointer">
								Badges {!isAscending ? '↑' : '↓'}
							</Th>
							<Th textAlign="center">{isMobile ? 'Top' : 'Percentage'}</Th>
							<Th />
						</Tr>
					</Thead>
					<Tbody>
						{sortedChecks.map((check, index) => (
							<RecentCheckItem
								key={index}
								check={check}
								onClick={onSelectAddress}
								onDelete={handleDelete}
							/>
						))}
					</Tbody>
				</Table>

				{/* Clear data button */}
				<Text
					mt={5}
					onClick={handleClearRecentChecks}
					textAlign={"center"}
					cursor={"pointer"}
					color="#FF684B"
					fontSize="md" // Set font size
					_hover={{
						textDecoration: "underline", // Underline on hover
					}}
				>
					Clear data
				</Text>
			</Box>
		)
	);
};

export default RecentChecksBadgesList;
